import AppConfig, { IS_DEVELOPMENT_ENV } from '@/AppConfig';
import { queryClient } from '@/context/CombinedProvider';
import Cookies from 'js-cookie';

export const redirectToPlumApp = (href: string) => () => {
  window.dev.i('Redirecting to Plum App', getPlumAppUrl(href));
  window.location.href = getPlumAppUrl(href);
};

export const removeJwtToken = async () => {
  await queryClient.invalidateQueries();
  Cookies.remove(AppConfig.JWT_TOKEN_COOKIE_NAME, {
    domain: IS_DEVELOPMENT_ENV ? 'localhost' : '.plumhq.com',
    path: '/',
  });
};

export const getPlumAppUrl = (href: string) => {
  return `${AppConfig.PLUM_APP_HOST_URL}${href}`;
};
